import type { RouteApiWithSearch } from '@/types/route-api-with-search'
import { type Sorting, type Order } from '@/types/sorting'

type RouteApiWithSorting = RouteApiWithSearch<{
  sort?: string
  order?: Order
  page: number
}>
const useSorting = <TRouteApi extends RouteApiWithSorting>(
  routeApi: TRouteApi
) => {
  const navigate = routeApi.useNavigate()
  const { order, sort } = routeApi.useSearch()

  const sorting: Sorting = sort && order ? { key: sort, order } : null
  const onChangeSorting = (value: Sorting | null) => {
    navigate({
      search: previousValue => ({
        ...previousValue,
        page: 1,
        ...(value
          ? { sort: value.key, order: value.order }
          : { sort: undefined, order: undefined })
      })
    })
  }

  return {
    sorting,
    onChangeSorting
  }
}

export { useSorting }
